import { Typography } from "@mui/material";
import { GridRenderCellParams } from "@mui/x-data-grid";

export const OrgDisinfectionCountCell = (params: GridRenderCellParams) => {
  return <Typography>{params.row.disinfectionCount} Disinfections</Typography>;
};
